import { Box, Paper, CircularProgress, Typography } from '@mui/material';

import { useCallback, useState } from 'react';

import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';

import styles from './IssuesObservationTable.module.scss';

const IssuesObservationTable = ({ issuesObservationData }: any) => {
	const IssuesObservationTableData = issuesObservationData;

	const [toastMessage, setToastMessageLocal] = useState('');
	const [isLoading] = useState<boolean>(false);
	const [isToastOpen, setIsToastOpen] = useState(false);

	const handleToast = useCallback(() => {
		setIsToastOpen(false);
		setToastMessageLocal('');
	}, []);

	const columns: readonly Column[] = [
		{
			id: 'testPlanName',
			label: 'Test Plan',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<Typography
					component="div"
					className={`${styles['processes-table-process-name']} ${params.testPlanName?.length}> 30 ? ${styles['processes-table-process-name-wrap']} : ''}`}
				>
					{params?.testPlanName ? params?.testPlanName : '--'}
				</Typography>
			),
		},

		{
			id: 'testAreaName',
			label: 'Test Area',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.testAreaName ? params?.testAreaName : '--'}</div>
			),
		},

		{
			id: 'testId',
			label: 'Test Record',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.testId ? params?.testId : '--'}</div>
			),
		},
		{
			id: 'recordType',
			label: 'Test Type',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.recordType ? params?.recordType : '--'}</div>
			),
		},
		{
			id: 'category',
			label: 'Issue/Observation',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.category ? params?.category : '--'}</div>
			),
		},
		{
			id: 'issueType',
			label: 'Issue Type',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.issueType ? params?.issueType : '--'}</div>
			),
		},
		{
			id: 'issueThemes',
			label: 'Issue Themes',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>{params?.issueThemes ? params?.issueThemes : '--'}</div>
			),
		},
	];

	return (
		<Box className={styles['processes-table-box']}>
			{IssuesObservationTableData &&
			IssuesObservationTableData.length > 0 &&
			!isLoading ? (
				<CommonTable
					id="IssuesObservationTable"
					rows={IssuesObservationTableData}
					columns={columns}
					defaultSortKey=""
					tableStyles={{ minWidth: 750, maxHeight: 440 }}
				/>
			) : (
				<div>
					{!isLoading ? (
						<Paper className={styles['processes-table-loading-box']}>
							<Typography data-testid="no-data-found">No data found</Typography>
						</Paper>
					) : (
						<Paper className={styles['processes-table-loading-box']}>
							<CircularProgress sx={{ color: '$btn-blue-dark' }} />
						</Paper>
					)}
				</div>
			)}

			<AlertComponent
				open={isToastOpen}
				toastMessage={toastMessage}
				severity="error"
				handleCloseMessage={handleToast}
				vertical="top"
				horizontal="right"
			/>
		</Box>
	);
};
export default IssuesObservationTable;
